import { useStaticQuery, graphql } from 'gatsby'
import { CmsContentService } from '@raysync/common/services'
import Fuse from 'fuse.js'

export const primaryTitleMap = {
  video: '演示视频',
  faq: 'FAQ',
  product: '操作指南',
  version: '版本信息',
  whitePaper: '白皮书',
}
const whitePapers = [
  '《镭速 FTP加速产品技术白皮书》',
  '《镭速 Proxy 产品技术白皮书》',
  '《镭速 RaySSH 产品技术白皮书》',
  '《镭速产品安全技术白皮书》',
  '《镭速传输协议技术白皮书》',
  '《镭速传输产品介绍精简版》',
  '《镭速传输JS-SDK集成》',
].map(paper => ({
  title: paper,
  type: 'whitePaper',
  primaryTitle: primaryTitleMap['whitePaper'],
  content: '',
  url: '/support/document/white-paper',
}))

export const useDocumentsQuery = () => {
  const data = useStaticQuery(
    graphql`
      query {
        documents: allContentfulDocument(filter: { isPrimaryMenu: { eq: true } }, sort: { fields: rank, order: ASC }) {
          nodes {
            menuChildren {
              slug
              title
              type
              menuChildren {
                title
                slug
                type
                tinyContent {
                  tinyContent
                }
                menuChildren {
                  title
                  slug
                  type
                  tinyContent {
                    tinyContent
                  }
                }
              }
              tinyContent {
                tinyContent
              }
            }
            title
            slug
            type
            tinyContent {
              tinyContent
            }
          }
        }
      }
    `,
  )
  const documents = data?.documents?.nodes || []
  const allData = [...formatDocumentData(documents), ...whitePapers]
  SearchService.init(allData)
  return allData
}

const formatDocumentData = (data, title) => {
  return data
    .map(document => {
      const primaryTitle = document.type === 'product' ? title || document.title : primaryTitleMap[document.type]
      const { tinyContent, ...otherParams } = document
      if (document.menuChildren) {
        return formatDocumentData(document.menuChildren, primaryTitle)
      }
      return {
        ...otherParams,
        primaryTitle,
        url: `/support/document/${document.type}/${document.slug}`,
        content: tinyContent?.tinyContent || '',
      }
    })
    .flat()
}

function highlight(content, keyword) {
  if (!content || !keyword) return ''
  const regEx = new RegExp(keyword, 'gi')
  const highlightKeyword = '<span class="highlight">' + keyword + '</span>'
  const highlightedContent = content.replace(regEx, highlightKeyword)
  return highlightedContent
}
function removeHtmlTags(content) {
  let text = CmsContentService.getText(content)
  text = text.replace(/<\/?[^>]+(>|$)/g, '')
  text = text.replace(/\n/g, '')
  return text
}
export class SearchService {
  fuse
  searchResult = []
  static init(contents) {
    const fuseConfig = {
      threshold: 0.6,
      ignoreLocation: true,
      includeMatches: true,
      keys: [
        {
          name: 'title',
          weight: 7,
        },
        'content',
      ],
    }
    this.fuse = new Fuse(contents, fuseConfig)
  }
  static search(keyword) {
    if (!keyword) return []
    const result = this.fuse.search(keyword)
    const searchResult = result.map(({ item, matches }) => {
      const { title, content, ...params } = item
      let highlightTitle = title
      let highlightContent = removeHtmlTags(item.content).slice(0, 300)
      for (let match of matches) {
        if (match.key === 'title') {
          highlightTitle = highlight(item.title, keyword)
        }
        if (match.key === 'content') {
          highlightContent = highlight(highlightContent, keyword)
        }
      }
      return { ...params, highlightTitle, highlightContent }
    })
    this.searchResult = searchResult
    return searchResult
  }
}
